// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2YI6L","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__i-di3"};